{
  "table": {
    "id": "Pièce d'identité",
    "name": "Nom",
    "type": "Type",
    "nextDate": "Date suivante",
    "noOfAttachedProducts": "# Nombre de produits joints",
    "action": "Action",
    "noOfSchedules": "# d'horaires"
  },
  "action": "Modifier",
  "addModal": {
    "title": "Ajouter un nouvel horaire",
    "name": "Nom",
    "scheduleDate": "Date programmée",
    "addDate": "Ajouter une nouvelle date",
    "update": "Mettre à jour",
    "type": "Type",
    "manual": "Manuel",
    "auto": "Automatique",
    "create": "Créer",
    "updateTitle": "Mettre à jour les horaires",
    "duplicateError": "Il ne peut pas y avoir de double horaire!"
  },
  "modelName": "Horaire de négociation"
}
